import React from 'react';
import {useSelector} from 'react-redux';
import {t} from '@lingui/core/macro';

import BlankLayout from 'shared/ui/BlankLayout/BlankLayout';
import ConfirmChangeEmail from 'features/auth/ui/Auth/ConfirmChangeEmail';
import {isUserLoadingSelector, userSelector} from 'entities/user';

const ConfirmChangeEmailScreen: React.FC = () => {
    const isLoading = useSelector(isUserLoadingSelector);
    const user = useSelector(userSelector);

    return (
        <BlankLayout pageTitle={t`Подтверждение изменения E-mail`} isLoading={isLoading}>
            {user && <ConfirmChangeEmail user={user} />}
        </BlankLayout>
    );
};

export default ConfirmChangeEmailScreen;
